import Multiselect from 'multiselect-react-dropdown'
import React from 'react'
import { useRef } from 'react'

function MultiSelectDropdown({ placeholder, options, valueUpdater, defaultValue = []   }) {

    const mref = useRef();

    const handleSelectUpdate = () =>{
       valueUpdater(mref.current.getSelectedItems().map(s => s.value));
    }

    return (
        <Multiselect
            displayValue="key"
            className=' max-w-lg '
            style={{
                chips: { // To change css chips(Selected options)
                    background: "#28bf4b"
                },
                searchBox:{
                    "overflow-x":"scroll",
                    "max-height":"100px",
                }
                // optionContainer: { // To change css for dropdown options
                //     background: "#28bf4b"
                // },
            }}
            placeholder={placeholder}
            onKeyPressFn={function noRefCheck() { }}
            onRemove={handleSelectUpdate}
            onSearch={function noRefCheck() { }}
            onSelect={handleSelectUpdate}
            options={options}
            selectedValues={defaultValue}
            ref={mref}
        />
    )
}

export default MultiSelectDropdown